import React from 'react'
import classNames from 'classnames'
import { UserStatusEnum, useUserStatusColors } from '@/@data'

interface Props {
  status: UserStatusEnum
  isTable?: boolean
}

const palette: Record<string, string> = {
  success: 'bg-green-500 text-white',
  error: 'bg-red-500 text-white',
  warning: 'bg-yellow-500 text-black',
  secondary: 'bg-gray-400 text-white',
  primary: 'bg-blue-500 text-white',
  info: 'bg-sky-500 text-white'
}

const statusLabels: Record<UserStatusEnum, string> = {
  [UserStatusEnum.ACTIVE]: 'active',
  [UserStatusEnum.BLOCKED]: 'blocked',
  [UserStatusEnum.DISABLE]: 'disable',
  [UserStatusEnum.WAITING]: 'waiting',
  [UserStatusEnum.INACTIVE]: 'inactive',
  [UserStatusEnum.GUEST]: 'guest',
  [UserStatusEnum.GUEST_WAITING]: 'guest waiting',
  [UserStatusEnum.WAITING_DELETE]: 'waiting delete',
  [UserStatusEnum.DELETED]: 'deleted',
}

const GameStatusChip: React.FC<Props> = ({ status, isTable = false }) => {
  const colors = useUserStatusColors()
  const colorClass = palette[colors[status]]

  return (
    <div className='flex items-center gap-2 w-max'>
      <div
        className={classNames(
          'px-4 py-1 rounded-[999px] font-medium capitalize',
          isTable ? 'text-sm' : 'text-base',
          colorClass
        )}
      >
        {statusLabels[status]}
      </div>
    </div>
  )
}

export default GameStatusChip
